export const STORAGE_KEYS = {
  settings: 'mainSettings',
  tokenAccounts: 'tokenAccountsSettings',
};
